import React from "react";

import { Helmet } from "react-helmet";

interface FaviconProps {
	faviconUrl?: string | null | undefined;
}

const Favicon: React.FC<FaviconProps> = ({ faviconUrl }) => {
	const url = faviconUrl ? faviconUrl : "/logoicon.svg";
	return (
		<Helmet>
			<link rel="icon" href={url}></link>
		</Helmet>
	);
};

export default React.memo(Favicon);
